import { jsxs as a, jsx as m } from "react/jsx-runtime";
import { Icon as d } from "../../icon/icon.js";
import "react";
import { Text as s } from "../../text/text.js";
import i from "clsx";
import { b as f } from "../../../virginmediao2-momentum-icons-icons-far-BQVtGVjv.js";
import { FormItemError as u } from "../form-item/form-item-error.js";
import { s as t } from "../../../form-checkbox-group.module-3P9DVzCq.js";
const v = ({
  id: r,
  label: e,
  description: o = "",
  error: l,
  children: c
}) => /* @__PURE__ */ a(
  "div",
  {
    "data-testid": `form-multi-item-${r}`,
    className: i(t["form-multi-item"]),
    ...e && { "aria-labelledby": `form-multi-item-label-${r}` },
    role: "group",
    children: [
      e && /* @__PURE__ */ m(
        "div",
        {
          "data-testid": `form-multi-item-label-${r}`,
          id: `form-multi-item-label-${r}`,
          className: i(t["form-multi-item__label"]),
          children: /* @__PURE__ */ m(s, { size: "T300", weight: "regular", color: "default", children: e })
        }
      ),
      o && /* @__PURE__ */ m(
        "div",
        {
          "data-testid": `form-multi-item-description-${r}`,
          className: "form-multi-item__description",
          children: /* @__PURE__ */ m(s, { size: "T300", weight: "regular", color: "default", children: o })
        }
      ),
      /* @__PURE__ */ m(
        "div",
        {
          "data-testid": `form-multi-item-controls-${r}`,
          className: i(t["form-multi-item__controls"]),
          children: c
        }
      ),
      l && /* @__PURE__ */ a(
        u,
        {
          id: `form-item-error-${r}`,
          "data-testid": `form-item-error-${r}`,
          children: [
            /* @__PURE__ */ m(d, { icon: f }),
            /* @__PURE__ */ m("div", { className: t["form-item__error-message"], children: /* @__PURE__ */ m("p", { children: l }) })
          ]
        }
      )
    ]
  }
);
export {
  v as FormCheckboxGroup
};
